import {ICompositeNode} from "@feature/nodes/models/node-type";
import { RendererFunction } from '../types/renderer-function';
import {SectionWithSubtitle} from "../models/section-with-subtitle";
import {SectionWithSubtitleComponent} from "../components/section-with-subtitle.component";

export const sectionWithSubtitleRendererFunc : RendererFunction = (viewContainerRef, node) => {
    const component = viewContainerRef.createComponent(SectionWithSubtitleComponent);
    component.instance.children = (node as ICompositeNode<object>)?.Children;
    component.instance.section =  (node as ICompositeNode<SectionWithSubtitle>)?.Props;
}
